<template>
    <div :class="`hp_qna_item ${isOpen ? 'open' : ''}`" @click="handleOpen">
        <div class="hp_qna_top">
            <span class="marker">Q.</span>
            <p class="q_content">{{ q_content }}</p>
            <div class="ic_qna_arrow">
                <img src="@/assets/ic_qna_arrow.png" alt="" />
            </div>
        </div>
        <div class="hp_qna_bottom">
            <span class="marker">A.</span>
            <p class="a_content">{{ a_content }}</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        q_content: {},
        a_content: {},
    },
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        handleOpen() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>
<style lang="scss">
.hp_qna_item {
    font-family: 'Pretendard', sans-serif;
    letter-spacing: -0.025em;

    background: var(--white);
    border-radius: 20px;
    box-shadow: 0 0 16px rgba(241, 241, 241, 1);
    padding: 40px;

    cursor: pointer;

    @media screen and (max-width: 768px) {
        padding: 20px;
    }

    .marker {
        display: inline-block;
        margin-right: 16px;
        font-size: 24px;
        line-height: 24px;
        color: #b1b1b1;
        font-weight: 700;

        @media screen and (max-width: 768px) {
            font-size: 20px;
        }
    }

    .hp_qna_top,
    .hp_qna_bottom {
        display: flex;
        align-items: center;
    }

    .hp_qna_top {
        transition: padding 0.3s ease-in-out;

        .q_content {
            font-size: 22px;
            font-weight: 600;
            color: var(--black1);
            line-height: 24px;

            @media screen and (max-width: 768px) {
                font-size: 16px;
                margin-right: 20px;
            }
        }

        .ic_qna_arrow {
            margin-left: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            flex: none;

            img {
                transition: 0.3s ease-in-out;
            }
        }
    }

    .hp_qna_bottom {
        transition: 0.3s ease-in-out;
        max-height: 0;
        overflow: hidden;
        align-items: flex-start;

        .marker {
            color: var(--red);
        }

        .a_content {
            font-size: 18px;
            color: var(--black2);
            line-height: 24px;
            word-break: keep-all;
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }
    }

    &+.hp_qna_item {
        margin-top: 35px;
    }

    &.open {
        .ic_qna_arrow img {
            transform: rotate(180deg);
        }

        .hp_qna_top {
            padding-bottom: 40px;
            border-bottom: 1px solid var(--border-color1);
            @media screen and (max-width: 768px) {
                padding-bottom: 30px;
            }
        }

        .hp_qna_bottom {
            margin-top: 40px;
            max-height: 200px;
            @media screen and (max-width: 768px) {
                margin-top: 30px;
            }
        }
    }
}
</style>
